var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{class:['pill-container', { 'pill-text': _vm.onlyText }],style:({ minWidth: _vm.width }),attrs:{"pill":"","dark":"","color":_vm.chipColor}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }